import { Button, Checkbox, Col, Form, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import ConfirmationBox from "../../../../../../components/common/ConfirmationBox";

function Cancel({ workOrderNumber, setIsConfirmationBoxOpen }) {
  return (
    <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
      <h2>Cancel Work Order #{workOrderNumber}</h2>
      <p>Are you sure you want to cancel this work order?</p>
      <Form layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item label="Notes">
              <TextArea rows={3} placeholder="e.g no longer needed" />
              <p className="silver-text">Limit of 140 characters.</p>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <Checkbox> Include notes with status update to resident</Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <Checkbox disabled>  Include notes with status update to vendor</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <div className="action-buttons">
          <Button type="primary">Save</Button>
          <button
            className="cancel-btn"
            onClick={() => setIsConfirmationBoxOpen(false)}
          >
            Cancel
          </button>
        </div>
      </Form>
    </ConfirmationBox>
  );
}

export default Cancel;
